import { ClientCore, AccountState } from 'client-core';

import useClientCorePart from './useClientCorePart';

function useAccountState(clientCore: ClientCore): AccountState;
function useAccountState(clientCore: ClientCore | undefined): AccountState | undefined;

function useAccountState(clientCore: ClientCore | undefined): AccountState | undefined {
  return useClientCorePart(clientCore, 'accountState');
}

export default useAccountState;
